import React from "react";
import styled, { ThemeProvider } from "styled-components";

const WrapperDownload = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  background: ${(props) => props.theme.background};
  border-radius: 10px 40px 10px 40px;
  opacity: 0.9;

  @media screen and (max-width: 576px) {
    display: block;
    height: fit-content;
    border-radius: 0px 0px 0px 0px;
  }

  .content {
    text-align: center;
    width: 100%;
    height: 100%;
    margin: auto;
    padding: 30px;
  }

  .text-header {
    text-align: center;
    font-size: 50px;
    letter-spacing: 0px;
    color: #e8e8e0;
    text-shadow: inset 0px 1px 6px #00000029;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: 40px;

    @media screen and (max-width: 1200px) {
      font-size: 40px;
    }

    @media screen and (max-width: 1200px) {
      font-size: 35px;
    }

    @media screen and (max-width: 768px) {
      font-size: 30px;
    }

    @media screen and (max-width: 576px) {
      font-size: 20px;
    }
  }

  .text-body,
  p {
    text-align: center;
    font-size: 20px;
    font-weight: lighter;
    letter-spacing: 0px;
    color: #ffffff;
    text-shadow: inset 0px 1px 6px #00000029;
    line-height: 2.4;
    opacity: 1;

    @media screen and (max-width: 1200px) {
      font-size: 18px;
    }

    @media screen and (max-width: 1024px) {
      font-size: 16px;
    }

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }

    @media screen and (max-width: 576px) {
      font-size: 10px;
    }
  }
`;

const colorTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #E59801 0%, #FAEB57 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const SubAnounceComponent = ({ subAnounce, pageName }) => {
  return (
    <ThemeProvider theme={colorTheme[pageName]}>
      <WrapperDownload className="w-full mt-5">
        <div className="content">
          <div className="text-header">
            {subAnounce.header}
          </div>
          <div
            className="text-body"
            dangerouslySetInnerHTML={{
              __html: subAnounce.content,
            }}
          ></div>
        </div>
      </WrapperDownload>
    </ThemeProvider>
  );
};

export default SubAnounceComponent;
